import { createContext, useState } from "react";

const FarmerFilterContext = createContext({
  fullName: null,
  phoneNumber: null,
  provinceId: null,
  cityId: null,
  productId: null,
  sort: null,
  marked: null,
});

export const FarmerFilterProvider = ({ children }) => {
  const [fullName, setFullName] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [cityId, setCityId] = useState(null);
  const [productId, setProductId] = useState(null);
  const [sort, setSort] = useState(null);
  const [marked, setMarked] = useState(null);


  const fullNameAction = (data) => {
    setFullName(data);
  };
  const phoneNumberAction = (data) =>{
    setPhoneNumber(data)
  };
  const provinceIdAction = (data) =>{
    setProvinceId(data)
  };
  const cityIdAction = (data) =>{
    setCityId(data)
  };
  const productIdAction = (data) =>{
    setProductId(data)
  };
  const sortAction = (data) =>{
    setSort(data)
  };
  const markedAction = (data) =>{
    setMarked(data)
  };

  const resetFarmerAction =() => {
    setFullName(null)
    setPhoneNumber(null)
    setProvinceId(null)
    setCityId(null)
    setProductId(null)
    setSort(null)
    setMarked(null)
  }

  return(
    <FarmerFilterContext.Provider value={{fullName,fullNameAction,phoneNumber,phoneNumberAction,provinceId,provinceIdAction,cityId,cityIdAction,productId,productIdAction,sort,sortAction,marked,markedAction,resetFarmerAction}}>
        {children}
    </FarmerFilterContext.Provider>
  )
};

export default FarmerFilterContext